import type { ComponentProps } from 'react';
import { OwcTable } from '@one/react';

export type PocTableProps = ComponentProps<typeof OwcTable>;

export const PocTable: React.FC<PocTableProps> = (props) => <OwcTable {...props} />;
